import destroy from "./destroy";
import init from "./manual";

/**
 *
 * @param {IterableElementsProps | null | undefined} [targets]
 */
const reload = (targets) => {
  destroy(targets);
  init(targets);
};

export default reload;
